module.exports = __webpack_public_path__ + "img/lygjg.bafc3472.png";